// @ts-nocheck
import FieldDefinition, { FieldType } from "@insite/client-framework/Types/FieldDefinition";
import { TabDefinition } from "@insite/client-framework/Types/TabDefinition";

function field(
    name: string,
    editorTemplate: "CheckboxField" | "TextField" | "HorizontalRule" | "ImagePickerField" | "DateTimeField",
    defaultValue: any,
    fieldType: FieldType,
    sortOrder: number,
    tab?: TabDefinition,
): FieldDefinition {
    return {
        name,
        editorTemplate,
        defaultValue,
        fieldType,
        sortOrder,
        tab,
    };
}

export const PublishDate: FieldDefinition = field(
    "publishDate",
    "DateTimeField",
    `${new Date().toISOString()}`,
    "General",
    600,
    undefined,
);
